import { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { isEmbedded } from '../../../constants/config';
import { constructDocumentUrl, getCurrentAnnotationId } from '../../../lib/url';
import { getAnnotationBacklink } from '../../../routes/useAnnotationBacklink';

export type UseSplitExitResult = {
  handleLeave: () => void;
  cancelDialogOpen: boolean;
  closeCancelDialog: () => void;
  confirmLeave: () => void;
};

export const useSplitExit = ({
  hasChanges,
}: {
  hasChanges: boolean;
}): UseSplitExitResult => {
  const history = useHistory();
  const location = useLocation<{ backlink?: string }>();

  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);

  // No explicit cancel-annotation dispatch here: `useSplitSession`'s existing
  // unmount effect already calls `cancelStartedAnnotations` when confirm has
  // not succeeded, once the URL changes below and the component unmounts.
  const leave = () => {
    const destination = isEmbedded()
      ? constructDocumentUrl({
          id: getCurrentAnnotationId(location.pathname),
        })
      : (location.state?.backlink ?? getAnnotationBacklink());

    history.replace(destination);
  };

  const handleLeave = () => {
    if (hasChanges) {
      setCancelDialogOpen(true);
    } else {
      leave();
    }
  };

  const closeCancelDialog = () => setCancelDialogOpen(false);

  const confirmLeave = () => {
    setCancelDialogOpen(false);
    leave();
  };

  return { handleLeave, cancelDialogOpen, closeCancelDialog, confirmLeave };
};
